export const light = {
  primary: ["#4A4A4A", "#4D4D4D", "#4F4F4F", "#BEBEBE"],
  secondary: ["#ffffff"],
}

export const dark = {
  primary: ["#FFFFFF", "#FFFFFFBF", "#FFFFFF40"],
  secondary: ["#4D4D4D"],
}

export const getPrimaryColor = (theme = "light", variant = "none") => {
  if (theme === "dark") {
    if (variant === "opaque") {
      return dark.primary[1]
    }

    if (variant === "progressBg") {
      return dark.primary[2]
    }

    return dark.primary[0]
  }

  if (variant === "border" || variant === "progressBg") {
    return light.primary[3]
  }

  if (variant === "timer") {
    return light.primary[2]
  }

  if (variant === "progressBar") {
    return light.primary[1]
  }

  return light.primary[0]
}

export const getSecondaryColor = (theme) => {
  if (theme === "dark") {
    return dark.secondary[0]
  }
  return light.secondary[0]
}

export const getStyledPrimaryColor = (variant) => ({ theme }) => getPrimaryColor(theme, variant)
export const getStyledSecondaryColor = (variant) => ({ theme }) => getSecondaryColor(theme, variant)



// WEBPACK FOOTER //
// ./src/theme/palette.js